import { isNil, isObject } from 'lodash';

const FIELD_NAME_INDEXABLE_INDICATOR = '.x.';

export const sanitizeNameOfIndexableIndicator = (
  name: string,
  matchPattern = FIELD_NAME_INDEXABLE_INDICATOR,
) => {
  const index = name.indexOf(matchPattern);
  return index > -1 ? name.substring(index + matchPattern.length) : name;
};

const isNonNillObject = (obj: unknown) => isObject(obj) && !isNil(obj);

export const indexifyValues = <T>(
  obj: Record<string | number, unknown>,
  index: number,
  matchPattern = FIELD_NAME_INDEXABLE_INDICATOR,
): T => {
  const indexed = { ...obj };

  Object.keys(obj).forEach((k) => {
    if (isNonNillObject(indexed[k])) {
      if (Array.isArray(indexed[k])) {
        indexed[k] = (indexed[k] as unknown[]).map((item: unknown) => {
          if (Array.isArray(item)) {
            return item.map((innerItem: unknown) =>
              isNonNillObject(innerItem)
                ? indexifyValues(
                    innerItem as Record<string, unknown>,
                    index,
                    matchPattern,
                  )
                : innerItem,
            );
          }

          return isNonNillObject(item)
            ? indexifyValues(
                item as Record<string, unknown>,
                index,
                matchPattern,
              )
            : item;
        });
      } else
        indexed[k] = indexifyValues(
          indexed[k] as Record<string, unknown>,
          index,
          matchPattern,
        );
    } else if (
      typeof indexed[k] === 'string' &&
      indexed[k].includes(matchPattern)
    ) {
      indexed[k] = indexed[k].replace(matchPattern, `.${index}.`);
    }
  });

  return indexed as T;
};
